<template>
  <div>
    <BaseModal class="modalWorkpackages" />
  </div>
</template>
<script>

  import BaseModal from '../base/BaseModal'

  export default {
    name: 'ModalWorkpachages',

    components: {
      BaseModal
    },

    props: {
      label: String,
      description: String,
      excludePackageMessage: String,
      test: String
    }
  }
</script>
  <style lang="scss">
  .modalWorkpackages {
    position: relative;

    &__title {
      padding: 30px 40px 30px 40px;
      font-family: "FavoritC", Arial, Helvetica, sans-serif;
      font-size: 20px;
      text-align: left;

      @include mobile {
        font-size: 16px;
      }
    }
  }
  </style>
